import React, { FC, useEffect } from "react";
import { appInsights } from "../../appInsights";
import Layout from "@layout/default";
import { useNavigate } from "react-router";
import sessionService from "@services/session.service";
import { routeMap } from "@utils/constants";
import { isNull } from "lodash";

const dashBoardLandingClients:any = ["Marquee", "SightMD", "Wellbe"];

const HomePage: FC<any> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("HomePage.useEffect");
    appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);

    // if the client name is null, this means no client has logged in yet.
    // so redirect to login page instead of members or any other page
    if (isNull(sessionService?.getClient())) {
      navigate(routeMap["login"]);
    } else {
      if (dashBoardLandingClients.includes(sessionService?.getClient()?.clientName)) {
        navigate(routeMap["dashboard"]);
      } else {
        navigate(routeMap["members"]);
      }
    }
  }, [navigate]);

  return <Layout>Home</Layout>;
};

export default HomePage;
